import { Table, TableCell, TableRow, Typography } from "@mui/material";
import { ReactNode } from "react";

export const FieldHelpContent = ({ headerContent }: { headerContent?: ReactNode }) => {
  return (
    <>
      {headerContent}
      <Table sx={{ "& td": { borderBottom: 0, p: 1 } }}>
        <TableRow>
          <TableCell valign="top" sx={{ fontWeight: "bold" }}>
            First Name:
          </TableCell>
          <TableCell>
            Search on the first name of the candidate. <i>i.e. "John"</i>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell valign="top" sx={{ fontWeight: "bold" }}>
            Last Name:
          </TableCell>
          <TableCell>
            Search on the last name of the candidate. <i>i.e. "Doe"</i>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell valign="top" sx={{ fontWeight: "bold" }}>
            Email Address:
          </TableCell>
          <TableCell>
            Search on the email address(es) of the candidate. <i>i.e. "example@nasrecruitment.com"</i>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell valign="top" sx={{ fontWeight: "bold" }}>
            Phone Number:
          </TableCell>
          <TableCell>
            Search on the phone number(s) of the candidate. <i>i.e. "(440) 555-5555"</i>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell valign="top" sx={{ fontWeight: "bold" }}>
            Created Date:
          </TableCell>
          <TableCell>
            Search on the date the candidate was created. <i>i.e. "10/20/2023"</i>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell valign="top" sx={{ fontWeight: "bold" }}>
            Location Name:
          </TableCell>
          <TableCell>
            Search on the name of the location. <i>i.e. "Cleveland"</i>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell valign="top" sx={{ fontWeight: "bold" }}>
            Geolocation:
          </TableCell>
          <TableCell>
            Search on the candidates location within a radius by coordiates.{" "}
            <i>i.e. "100 miles from Cleveland, OH"</i>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell valign="top" sx={{ fontWeight: "bold" }}>
            Label Variants:
          </TableCell>
          <TableCell>
            After editing a field label, historical labels appear in a tooltip.{" "}
            <i>
              i.e. "Custom Field 1 is true" matches candidates who filled out "Custom Field 1 (old label)" and
              candidates who filled out "Custom Field 1"
            </i>
          </TableCell>
        </TableRow>
      </Table>
    </>
  );
};

export const CommandHelpContent = ({ headerContent }: { headerContent?: ReactNode }) => {
  return (
    <>
      {headerContent}
      <Typography variant="h5" sx={{ p: 1, borderBottom: "1px solid", borderColor: "grey.400" }}>
        Text
      </Typography>
      <Table sx={{ "& td": { borderBottom: 0, p: 1 } }}>
        <TableRow>
          <TableCell valign="top" sx={{ fontWeight: "bold" }}>
            Includes:
          </TableCell>
          <TableCell>
            Search for a value within text. <i>i.e. "Example item" includes "ample"</i>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell valign="top" sx={{ fontWeight: "bold" }}>
            Starts With / Ends With:
          </TableCell>
          <TableCell>
            Search text that starts or ends with a value. <i>i.e. "Example Candidate" starts with "Exam"</i>
          </TableCell>
        </TableRow>
        <TableRow sx={{ borderBottom: 0 }}>
          <TableCell valign="top" sx={{ fontWeight: "bold" }}>
            Is:
          </TableCell>
          <TableCell>
            Exact match search on a field. <i>i.e. "John Doe" is "John Doe"</i>
          </TableCell>
        </TableRow>
      </Table>
      <Typography variant="h5" sx={{ p: 1, borderBottom: "1px solid", borderColor: "grey.400" }}>
        Geolocation
      </Typography>
      <Typography variant="body2">
        This allows you to search for candidates using a range and coordinates.
      </Typography>
      <Table sx={{ "& td": { borderBottom: 0, p: 1 } }}>
        <TableRow>
          <TableCell valign="top" sx={{ fontWeight: "bold" }}>
            Greater / Greater Than Equal:
          </TableCell>
          <TableCell>
            Search for candidates that are more than x miles from a location.{" "}
            <i>i.e. "Candidates more than 100 miles from Cleveland Ohio"</i>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell valign="top" sx={{ fontWeight: "bold" }}>
            Less than / Less than or Equal:
          </TableCell>
          <TableCell>
            Search for candidates that are less than x miles from a location.{" "}
            <i>i.e. "Candidates less than 100 miles from Cleveland Ohio."</i>
          </TableCell>
        </TableRow>
      </Table>
      <Typography variant="h5" sx={{ p: 1, borderBottom: "1px solid", borderColor: "grey.400" }}>
        Dates
      </Typography>
      <Table sx={{ "& td": { borderBottom: 0, p: 1 } }}>
        <TableRow>
          <TableCell valign="top" sx={{ fontWeight: "bold" }}>
            After / After or On:
          </TableCell>
          <TableCell>
            Search for candidates that were created after a date.{" "}
            <i>i.e. "Candidates created after "10/10/2023"</i>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell valign="top" sx={{ fontWeight: "bold" }}>
            Before / Before or On:
          </TableCell>
          <TableCell>
            Search for candidates that were created before a date.{" "}
            <i>i.e. "Candidates created before "10/10/2023"</i>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell valign="top" sx={{ fontWeight: "bold" }}>
            Between:
          </TableCell>
          <TableCell>
            Search for candidates that were created between two dates.{" "}
            <i>i.e. "Candidates created between "10/10/2023" and "10/20/2023"</i>
          </TableCell>
        </TableRow>
      </Table>
    </>
  );
};
